'use client';

import dynamic from 'next/dynamic';

export const AddressSearch = dynamic(
  () => import('./AddressSearch').then(mod => mod.AddressSearch),
  {
    ssr: false,
  }
);
